const Table = ({ columns, data, emptyMessage }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 bg-white rounded-lg shadow">
        <p className="text-gray-500">{emptyMessage || 'No data available'}</p>
      </div>
    );
  }

  const getValue = (obj, path) => {
    if (!path) return obj;
    return path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : null), obj);
  };

  return (
    <div className="overflow-x-auto rounded-lg shadow bg-white">
      <table className="min-w-full divide-y divide-[#E6CCB2]">
        <thead className="bg-[#F2D0A9]">
          <tr>
            {columns.map((column) => (
              <th
                key={column.header}
                className="px-5 py-3 text-left text-xs font-medium text-[#2E1F27] uppercase tracking-wider"
              >
                <div className="flex items-center space-x-1">
                  <span>{column.header}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-[#E6CCB2]">
          {data.map((row, rowIndex) => (
            <tr 
              key={rowIndex}
              className="hover:bg-[#E6CCB2]/10 transition-colors duration-200"
            >
              {columns.map((column, colIndex) => {
                const value = getValue(row, column.accessor);
                return (
                  <td 
                    key={`${rowIndex}-${colIndex}`}
                    className="px-5 py-4 whitespace-nowrap text-sm text-[#2E1F27]"
                  >
                    {column.Cell ? column.Cell({ value, row: { original: row } }) : value}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;